
  // var $jq = jQuery.noConflict();
  // $jq(document).ready(function () {
  // $jq(".section-{{section.id}} .container").slick({
  //   dots: true,
  //   // centerMode: true,
  //   infinite: true,
  //   centerPadding: '100px',
  //   slidesToShow: {{ section.settings.logos_per_row }},
  //   slidesToScroll: 1, 
  //   responsive: [
  //   {
  //     breakpoint: 1024,
  //     settings: {
  //       slidesToShow: 4,
  //       centerPadding: '50px',
  //       slidesToScroll: 1
  //     }
  //   },
  //   {
  //     breakpoint: 600,
  //     settings: {
  //       slidesToShow: 3,
  //       centerPadding: '30px',
  //       slidesToScroll: 1,
  //   	arrows : false
  //     }
  //   },
  //   {
  //     breakpoint: 480,
  //     settings: {
  //       slidesToShow: 1,
  //       centerMode: true,
  //       centerPadding: '50px',
  //   	arrows : true,
  //       slidesToScroll: 1
  //     }
  //   }
  // ]
  // });
  //   });



  //cart header total product Count Script 

 document.addEventListener("rebuy.ready", function () {
    function updateCartCount() {
      const items = document.querySelectorAll('ul[data-smartcart-items] li.rebuy-cart__flyout-item');
      const count = items.length; 
      const titleEl = document.getElementById("SmartCart_title");

      if (titleEl) {
        titleEl.textContent = `Cart (${count}${count === 1 ? '' : ''})`;
      }
    }
    updateCartCount();
    setInterval(updateCartCount, 2000);
    document.addEventListener("rebuy:cart.change", updateCartCount);
    document.addEventListener("rebuy:smartcart.open", updateCartCount);
  });



  //add Product tag with Product Title

document.addEventListener("rebuy.ready", function () {
  function updateProductTags() {
    document.querySelectorAll('ul[data-smartcart-items] li.rebuy-cart__flyout-item').forEach(item => {
      const tagClasses = Array.from(item.classList).filter(cls =>
        cls.startsWith('tag-') && !cls.startsWith('tag-property')
      );
      const tags = tagClasses.map(t => t.replace('tag-', ''));

      const titleEl = item.querySelector('.rebuy-cart__flyout-item-product-title');
      if (titleEl && tags.length > 0) {
        const oldTagEl = titleEl.querySelector('.custom-tags');
        if (oldTagEl) oldTagEl.remove();
        const firstTag = tags[0];

        const span = document.createElement('span');
        span.className = 'custom-tags';
        span.textContent = ` ${firstTag}`;
        titleEl.appendChild(span);
      }
    });
  }

  setInterval(updateProductTags, 2000);
  document.addEventListener("rebuy:cart.change", updateProductTags);
  document.addEventListener("rebuy:smartcart.open", updateProductTags);
});


//Subtotal Text Hide
document.addEventListener("rebuy.ready", function () {
  function updateSubtotalLabel() {
    const subtotalLabel = document.querySelector('.rebuy-cart__flyout-subtotal-label span');
    if (subtotalLabel) {
      subtotalLabel.textContent = 'Subtotal';
    }
  }
  updateSubtotalLabel();
  document.addEventListener("rebuy:cart.change", updateSubtotalLabel);
  document.addEventListener("rebuy:smartcart.open", updateSubtotalLabel);
  setInterval(updateSubtotalLabel, 1000);
});